import './quotesCarousel.scss';
import * as React from 'react';
import Swiper from 'react-id-swiper';
import { useSwiperSlide } from '../../hooks/useSwiperSlide';
import { SwiperUtils } from '../../utils/swiper';
import { NavigationButtons } from '../navigation/navigationButtons';
import Quote from './quote';
export const QuotesCarousel = ({ quotes }) => {
    const swiperProps = React.useMemo(() => ({
        ...SwiperUtils.Config.defaults(),
        ...SwiperUtils.Config.perView(1, {
            780: 2,
        }),
    }), []);
    const { setSwiper, onFirstSlide, onLastSlide, nextSlide, prevSlide } = useSwiperSlide();
    return (<div className="quotes-container">
      <NavigationButtons onClickNext={nextSlide} onClickPrev={prevSlide} canGoNext={!onLastSlide} canGoPrev={!onFirstSlide}/>

      <Swiper {...swiperProps} getSwiper={setSwiper}>
        {quotes.map((quote) => (<div key={quote.author.name}>
            <Quote {...quote} key={quote.quoteText}/>
          </div>))}
      </Swiper>
    </div>);
};
export default QuotesCarousel;
